/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import Money from 'components/money';

const HIDDEN_PLAN_IDS = [
    'backup#win-server-no-setup#1month',
    'backup#win-10-11-no-setup#1month',
];

const Plan = ({ plan, onClick, disabled, selected }) => {
    if (HIDDEN_PLAN_IDS.includes(plan.id)) return null;

    return (
        <div
            className={classNames('subscribe-plan', {
                'subscribe-plan--selected': selected,
                'subscribe-plan--disabled': disabled,
            })}
            onClick={onClick}
        >
            <div className='subscribe-plan__info'>
                <div className='subscribe-plan__name'>{plan.name}</div>
                {plan.description && (
                    <div className='subscribe-plan__description'>{plan.description}</div>
                )}
            </div>
            <div className='subscribe-plan__right'>
                <div className='subscribe-plan__price'>
                    <Money value={plan.price / 100} />
                    <span className='subscribe-plan__period'> / {plan.period} {plan.period_unit}</span>
                </div>
                <div className='subscribe-plan__cta'>
                    {selected ? 'Current plan' : 'Select this plan →'}
                </div>
            </div>
        </div>
    );
};

export default Plan;
